import { Component } from '@angular/core';
import { StateService } from '@app/core/services/state.service';

@Component({
    selector: 'tt-consignment-menu',
    templateUrl: './consignment-menu.component.html',
    styleUrls: ['./consignment-menu.component.css'],
})
export class ConsignmentMenuComponent {
    /**
     * The name of the consignment webpagemenu to load into generic webpagemnu component.
     */
    public webpageName = '';

    constructor(private state: StateService) {
        this.webpageName = this.state.getCurrentName();
    }
}
